export default "__VITE_ASSET__BzAMF5my__"